<template>
  <div class="card renewal">
    <div class="card-header">Renewal Chain</div>
    <div class="card-body">
      <div class="row" v-if="grid.length">
        <div class="col-4 offset-md-8">
          <div class="row legend text-center">
            <div class="col-3"><span class="rehost" /> Rehost</div>
            <div class="col-3"><span class="none" /> Active</div>
            <div class="col-3"><span class="renew" /> Renew</div>
            <div class="col-3"><span class="return" /> Return</div>
          </div>
        </div>
      </div>
      <div class="card-deck" v-if="grid.length">
        <div v-for="(grid, i) in grid" :key="grid[0]" class="card-container">
          <div class="card" v-if="grid.length > 1">
            <div class="card-header normal text-center font-weight-bold">{{ grid[0] }}</div>
            <ul style="list-style-type: none; padding: 0; margin: 0;">
              <li :key="item.ID" v-for="(item, j) in getCountItems(grid)" class="list-item">
                <div v-for="index in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index" style="width: 5px;">
                  <template
                    v-if="
                      hasChildInSameColumn(getCountItems(grid), item.ID) &&
                      randomNumberMap[i][j] === index
                    "
                  >
                    <div
                      :id="hasChildInSameColumn(getCountItems(grid), item.ID) ? item.ID : ''"
                      :class="`item no connector ${getColorClass(getLicenseStatus(item.LIFECYCLE_STATUS))}`"
                      :data-status="getLicenseStatus(item.LIFECYCLE_STATUS)"
                    />
                  </template>
                  <template v-else>
                    <div class="connector" />
                  </template>
                </div>
                <div
                  :class="getItemClasses(item, getCountItems(grid))"
                  :ref="item.ID"
                  :id="hasChildInSameColumn(getCountItems(grid), item.ID) ? '' : item.ID"
                  :data-parent-id="item.PARENT_FULFILLMENT"
                  :data-status="getLicenseStatus(item.LIFECYCLE_STATUS)"
                  v-b-tooltip.hover
                  :title="!!item.ACTIVATION_COUNT ? getLicenseStatus(item.LIFECYCLE_STATUS, true) : ''"
                  :data-original-title="!!item.ACTIVATION_COUNT ? getLicenseStatus(item.LIFECYCLE_STATUS, true) : ''"
                >
                  <template v-if="!!item.ACTIVATION_COUNT">
                    <span>{{ item.ACTIVATION_COUNT }}</span>
                  </template>
                  <template v-else>
                    <span class="white-text">000</span>
                  </template>
                </div>
                <div v-for="index in [11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" :key="index">
                  <template
                    v-if="
                      hasChildInSameColumn(getCountItems(grid), item.ID) &&
                      randomNumberMap[i][j] === index
                    "
                  >
                    <div
                      :id="hasChildInSameColumn(getCountItems(grid), item.ID) ? item.ID : ''"
                      :class="`item no connector ${getColorClass(getLicenseStatus(item.LIFECYCLE_STATUS))}`"
                      :data-status="getLicenseStatus(item.LIFECYCLE_STATUS)"
                    />
                  </template>
                  <template v-else>
                    <div class="connector" />
                  </template>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p v-else class="text-center">There are no items to show</p>
    </div>
  </div>
</template>

<script>
import uuid from 'uuid/v1'

import LicenseCheckerCircle from './license-checker-circle'

export default {
  name: 'LicenseCheckerRenewalChain',
  components: { LicenseCheckerCircle },
  props: {
    grid: { type: Array, default: () => ([]) }
  },
  data () {
    return {
      randomNumberMap: this.grid.reduce((acc, cur, i) => {
        acc[`${i}`] = cur.reduce((acc1, cur1, j) => {
          if (j) {
            acc1[`${j - 1}`] = this.randomNumber()
          }
          return acc1
        }, {})
        return acc
      }, {})
    }
  },
  watch: {
    grid () {
      this.removeLines()
      this.drawLines()
    }
  },
  mounted () {
    this.drawLines()
  },
  beforeDestroy () {
    this.removeLines()
  },
  updated () {
    this.removeLines()
    this.drawLines()
  },
  methods: {
    getCountItems (gridList) {
      return [ ...gridList ].splice(1, gridList.length - 1).map((g) => {
        if (!g) return [{ ID: uuid() }]
        return g
      })
    },
    getLicenseStatus (status, capitalizeFirstWord = false) {
      if (!status) return capitalizeFirstWord ? 'Active' : 'none' // eslint-disable-line
      status = status.replace('bo.constants.lifecycle.status.', '')
      return capitalizeFirstWord
        ? `${status[0].toUpperCase()}${status.split('').splice(1).join('')}`
        : status
    },
    getItemClasses (item, grid = []) {
      const classes = ['text-center']
      if (this.hasChildInSameColumn(this.getCountItems(grid), item.ID)) {
        classes.push(`${item.ID}`)
      }
      if (!!item.ACTIVATION_COUNT) { // eslint-disable-line
        classes.push('item')
      } else {
        classes.push('item no')
      }
      if (item.PARENT_FULFILLMENT) {
        classes.push(`is-parent ${item.PARENT_FULFILLMENT}`)
      }
      classes.push(this.getColorClass(this.getLicenseStatus(item.LIFECYCLE_STATUS)))
      return classes
    },
    getColorClass (status) {
      return ({
        rehost: 'rehost',
        none: 'none',
        renew: 'renew',
        return: 'return'
      })[status]
    },
    hasChildInSameColumn (grid, id) {
      return !!grid.find(g => g.PARENT_FULFILLMENT === id) &&
        !!grid.find((g, i) => grid[i + 1] && grid[i + 1].PARENT_FULFILLMENT === g.ID)
    },
    drawLines () {
      const getColorClass = this.getColorClass
      $('.is-parent').each(function () { // eslint-disable-line
        const id = $(this).attr('id') // eslint-disable-line
        const parentId = $(this).attr('data-parent-id') // eslint-disable-line
        $().connections({ // eslint-disable-line
          from: `#${parentId}`,
          to: `#${id}`,
          within: '.renewal .card-deck',
          class: getColorClass($(`#${parentId}`).attr('data-status')) // eslint-disable-line
        })
        $().connections({ // eslint-disable-line
          from: `#${parentId}`,
          to: `.${parentId}`,
          within: '.renewal .card-deck',
          class: getColorClass($(`#${parentId}`).attr('data-status')) // eslint-disable-line
        })
      })
    },
    removeLines () {
      // eslint-disable-next-line
      $('connection').each(function () {
        $(this).remove() // eslint-disable-line
      })
    },
    randomNumber () {
      const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
      return numbers[Math.floor(Math.random() * numbers.length)]
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../styles/variables.scss';

p {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.renewal.card {
  margin-bottom: 100px;
  margin-top: 30px;
}

.renewal .card-deck {
  overflow-x: auto;
  flex-flow: row nowrap;
  padding-bottom: 50px;
  position: relative;
}

.renewal .card-deck .card-container .card {
  min-width: 352px;
  width: 352px;
  flex: 0 0 352px;
  margin-left: 0;
  margin-right: 60px;
}

.renewal .card-deck .card-container:first-child .card {
  margin-left: 15px;
}

.renewal .card-deck .card-container:last-child .card {
  margin-right: 15px;
}

.renewal .card-body {
  padding-bottom: 0;
}

.list-group.list-group-flush {
  position: relative;
}

.has-parent:before {
  content: '\2192';
  position: absolute;
  left: -55px;
  top: -15px;
  font-size: 3rem;
  color: $success;
}

.white-text {
  color: $white;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

connection {
  border-width: 3px;
  border-style: solid;
  z-index: 99999;
}

.list-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item  {
  width: 50px;
  min-width: 50px;
  height: 50px;
  min-height: 50px;
  display: flex;
  border-radius: 50%;
  border: 3px solid #202020;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
  font-size: 0.8rem;
  background-color: white;
  z-index: 99999;
}

.item.no {
  border: none;
}

.connector {
  width: 5px;
  min-width: 5px;
  height: 5px;
  min-height: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

.connector.r {
  margin-right: 7px;
}

.rehost {
  border-color: #265760;
}

.rehost.item,
.legend .rehost {
  background: #265760;
  color: white;
}

.none:not(.no) {
  border-color: #a5c64f;
}

.none.item:not(.no),
.legend .none {
  background: #a5c64f;
  color: white;
}

.renew {
  border-color: #FFBC42;
}

.renew.item,
.legend .renew {
  background: #FFBC42;
}

.return {
  border-color: #6B6B6B;
}

.return.item,
.legend .return {
  background: #6B6B6B;
  color: white;
}

.legend {
  font-size: 0.82rem;
  margin-top: -10px;
  margin-bottom: 10px;
}

.legend .renew,
.legend .rehost,
.legend .none,
.legend .return {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
}

.tooltip {
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-renewal-chain.vue